import { Button } from 'primereact/button';
import { AuthProvider } from './context/AuthContext';
import { LateralMenu, TopMenu } from './components/PageMenu';
import { Outlet, RouterProvider, createBrowserRouter } from 'react-router-dom';
import Home from './pages/home/Home';
import { UserProvider } from './context/UserContext';
import { ToastProvider } from './context/ToastContext';
import UsersPage from './pages/users/UsersPage';
import UserFormPage from './pages/users/UserFormPage';
import IndustriesPage from './pages/industries/IndustriesPage';
import ProductsPage from './pages/products/ProductsPage';
import ClientsPage from './pages/clients/ClientsPage';
import ClientFormPage from './pages/clients/ClientFormPage';
import OrdersPage from './pages/orders/OrdersPage';
import NewOrderPage from './pages/orders/NewOrderPage';
import SupplierConfigurations from './pages/supplier-configurations/SupplierConfigurations';

const Layout = () => (
  <>
    <TopMenu/>
    <div className='h-screen hidden md:flex flex-column border-right-1 border-200 p-4' style={{ minWidth: 300 }}>
      <LateralMenu/>
    </div>
    <div className='h-screen flex-grow-1 px-3 md:px-5 pt-5 md:pt-7 overflow-y-scroll	'>
      <Outlet/>
    </div>
  </>
);

const router = createBrowserRouter([{
  path: "/",
  element: <Layout/>,
  children: [{
    path: '/',
    element: <Home/>
  }, {
    path: 'users',
    element: <UsersPage/>
  }, {
    path: 'users/:id',
    element: <UserFormPage/>
  }, {
    path: 'industries',
    element: <IndustriesPage/>
  }, {
    path: 'products',
    element: <ProductsPage/>
  }, {
    path: 'clients',
    element: <ClientsPage/>
  }, {
    path: 'clients/:id',
    element: <ClientFormPage/>
  }, {
    path: 'orders',
    element: <OrdersPage/>
  }, {
    path: 'orders/new',
    element: <NewOrderPage/>
  }, {
    path: 'supplier-configurations',
    element: <SupplierConfigurations/>
  }]
}]);

function App() {
  return (
    <ToastProvider>
      <AuthProvider>
        <UserProvider>
          <div className="App w-screen h-screen flex flex-column md:flex-row">
            <RouterProvider router={router} />
          </div>
        </UserProvider>
      </AuthProvider>
    </ToastProvider>
  );
}

export default App;
